import { render, staticRenderFns } from "./ses-send-email-input.vue?vue&type=template&id=531974d0&scoped=true"
import script from "./ses-send-email-input.vue?vue&type=script&lang=js"
export * from "./ses-send-email-input.vue?vue&type=script&lang=js"
import style0 from "./ses-send-email-input.vue?vue&type=style&index=0&id=531974d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531974d0",
  null
  
)

export default component.exports